// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yz92xE {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.dnD2Pu {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.E6_2A_ {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.UOOClE {
  padding: var(--spacing-3) var(--spacing-1-5) 0;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.fjgwDg {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-1);
}

.wzjTbl {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: var(--spacing-3);
  height: var(--spacing-3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.wzjTbl img {
  width: var(--spacing-2);
  height: var(--spacing-2);
}

.Cdfg22 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.OAYLs1 {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.OITtEp {
  margin: 0;
  padding-left: var(--spacing-4);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm, 12px);
  line-height: var(--line-height-160);
  color: #000000;
}

.Ax5uU2 {
  min-width: 0;
  width: 100%;
  margin: 0;
}

.ZFfQE9 {
  padding: var(--spacing-3);
  border-top: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  background: var(--surface-neutral-white);
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
}

.ub86Q5 {
  grid-template-columns: 1fr;
}

.M_P3wT {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
}

.n2JFir {
  margin: 0;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-m);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.MLtG_w {
  margin: 0;
  max-width: 200px;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-m);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.TBJxFD {
  background-color: var(--neutral-dark-opacity-50) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/EmissorBeneficiariesValues/components/EmissorBeneficiaryEditModal/EmissorBeneficiaryEditModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,oCAAoC;EACpC,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,2DAA2D;AAC7D","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-1-5) 0;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.titleAction {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-1);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.requiredLegend {\n  margin: 0;\n  padding-left: var(--spacing-4);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm, 12px);\n  line-height: var(--line-height-160);\n  color: #000000;\n}\n\n.documentAlert {\n  min-width: 0;\n  width: 100%;\n  margin: 0;\n}\n\n.modalFooter {\n  padding: var(--spacing-3);\n  border-top: none;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  background: var(--surface-neutral-white);\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.modalFooterSingle {\n  grid-template-columns: 1fr;\n}\n\n.pendingNotice {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n}\n\n.pendingTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-m);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.pendingDescription {\n  margin: 0;\n  max-width: 200px;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-m);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `yz92xE`,
	"modalDialog": `dnD2Pu`,
	"modalContent": `E6_2A_`,
	"modalHeader": `UOOClE`,
	"titleAction": `fjgwDg`,
	"backButton": `wzjTbl`,
	"modalTitle": `Cdfg22`,
	"modalBody": `OAYLs1`,
	"requiredLegend": `OITtEp`,
	"documentAlert": `Ax5uU2`,
	"modalFooter": `ZFfQE9`,
	"modalFooterSingle": `ub86Q5`,
	"pendingNotice": `M_P3wT`,
	"pendingTitle": `n2JFir`,
	"pendingDescription": `MLtG_w`,
	"backdrop": `TBJxFD`
};
module.exports = ___CSS_LOADER_EXPORT___;
